import styles from'./Progress.module.scss';
function Progress() {
    return (
        <>
            <div className="components_wrap">
                <div className={styles.cont_box}>
                    {/* <ul className={styles.m_i_ul_2}>
                        <li>회원의 임기는 심사 이듬해 1월 1일부터 시작됩니다.</li>
                        <li>정회원은 현 일반회원 중에서 정회원의 추천을 받아, 약 1년간의 심사를 거쳐 선정되고 있습니다.</li>
                    </ul> */}
{/* ---------------------------------- */}
                    <ul className={styles.step_wrap}>
                        <li className={styles.step_wrap_li}>
                            <div className={styles.step_area}>
                                <div className={styles.step}>
                                    <strong>STEP 1</strong>
                                    <span>3월</span>
                                </div>
                            </div>
                            <div className={styles.step_box}>
                                <strong><font className="f_c_blue">이사회</font></strong>
                                <div className={`${styles.bn_wrap} ${styles.step_list}`}>
                                    <ul className={styles.bul_list}>
                                        <li>“회원추천·심사 권고사항 및 운영지침” 수립</li>
                                    </ul>
                                </div>
                                <span className={styles.bg_m}></span>
                            </div>
                        </li>
{/* ---------------------------------- */}
                        <li className={styles.step_wrap_li}>
                            <div className={styles.step_area}>
                                <div className={styles.step}>
                                    <strong>STEP 2</strong>
                                    <span>5~6월</span>
                                </div>
                            </div>
                            <div className={styles.step_box}>
                                <strong><font className="f_c_blue">예비추천서</font> 접수</strong>
                                <div className={`${styles.bn_wrap} ${styles.step_list}`}>
                                    <ul className={styles.bul_list}>
                                        <li>회원 추천권자(정회원, 단체회원 대표, 임원 및 명예이사)를 대상으로 예비추천서 요청 및 접수</li>
                                        <li>원로회원 심사 및 연임심사 대상자 안내</li>
                                    </ul>
                                </div>
                                <span className={styles.bg_m}></span>
                            </div>
                        </li>
{/* ---------------------------------- */}
                        <li className={styles.step_wrap_li}>
                            <div className={styles.step_area}>
                                <div className={styles.step}>
                                    <strong>STEP 3</strong>
                                    <span>7월</span>
                                </div>
                            </div>
                            <div className={styles.step_box}>
                                <strong>회원 후보자 <font className="f_c_blue">지원서</font> 접수</strong>
                                {/* <span className={styles.bul}>후보자 업적 자료</span> */}
                                <div className={`${styles.bn_wrap} ${styles.step_list}`}>
                                    <ul className={styles.bul_list}>
                                        <li>예비 추천된 회원 후보자에게 지원서 작성 안내</li>
                                        <li>회원 후보자의 업적 및 신상 자료 접수</li>
                                    </ul>
                                </div>
                                <span className={styles.bg_m}></span>
                            </div>
                        </li>
{/* ---------------------------------- */}
                        <li className={styles.step_wrap_li}>
                            <div className={styles.step_area}>
                                <div className={styles.step}>
                                    <strong>STEP 4</strong>
                                    <span>8월</span>
                                </div>
                            </div>
                            <div className={styles.step_box}>
                                <strong><font className="f_c_blue">추천서</font> 접수</strong>
                                {/* <span className={styles.bul}>각 분과별 심사위원 위촉</span> */}
                                <div className={`${styles.bn_wrap} ${styles.step_list}`}>
                                    <ul className={styles.bul_list}>
                                        <li>추천자가 회원 후보자의 지원서를 확인한 후 추천서 작성</li>
                                        <li>추천서 접수를 끝으로 추천 절차 마무리</li>
                                    </ul>
                                </div>
                                <span className={styles.bg_m}></span>
                            </div>
                        </li>
{/* ---------------------------------- */}
                        <li className={styles.step_wrap_li}>
                            <div className={styles.step_area}>
                                <div className={styles.step}>
                                    <strong>STEP 5</strong>
                                    <span>9월</span>
                                </div>
                            </div>
                            <div className={styles.step_box}>
                                <strong>전문분과별 <font className="f_c_blue">심사위원 평가소견서</font> 접수</strong>
                                {/* <span className={styles.bul}>분과 회원심사 위원 개별 평가</span> */}
                                <div className={`${styles.bn_wrap} ${styles.step_list}`}>
                                    <ul className={styles.bul_list}>
                                        <li>8개 전문분과 심사위원이 해당 분과 회원 후보자에 대한 개별 평가 진행</li>
                                    </ul>
                                </div>
                                <span className={styles.bg_m}></span>
                            </div>
                        </li>
{/* ---------------------------------- */}
                        <li className={styles.step_wrap_li}>
                            <div className={styles.step_area}>
                                <div className={styles.step}>
                                    <strong>STEP 6</strong>
                                    <span>10월</span>
                                </div>
                            </div>
                            <div className={styles.step_box}>
                                <strong><font className="f_c_blue">전문분과별 회원심사</font> 소위원회 심사</strong>
                                {/* <span className={styles.bul}>6개 분과 개별 심사 회의 개최</span> */}
                                <div className={`${styles.bn_wrap} ${styles.step_list}`}>
                                    <ul className={styles.bul_list}>
                                        <li>8개 전문분과별 회원심사 소위원회 심사를 통해 회원위원회 상정 후보자 명단 확정</li>
                                        <li>원로회원 심사, 정회원 및 일반회원 연임심사 진행</li>
                                    </ul>
                                </div>
                                <span className={styles.bg_m}></span>
                            </div>
                        </li>
{/* ---------------------------------- */}
                        <li className={styles.step_wrap_li}>
                            <div className={styles.step_area}>
                                <div className={styles.step}>
                                    <strong>STEP 7</strong>
                                    <span>11월</span>
                                </div>
                            </div>
                            <div className={styles.step_box}>
                                <strong><font className="f_c_blue">회원위원회 심사</font></strong>
                                {/* <span className={styles.bul}>회원위원회 위원 투표</span> */}
                                <div className={`${styles.bn_wrap} ${styles.step_list}`}>
                                    <ul className={styles.bul_list}>
                                        <li>8개 분과 회원 후보자 전체에 대한 통합 심사</li>
                                        <li>이사회 상정 후보자 명단 확정</li>
                                    </ul>
                                </div>
                                <span className={styles.bg_m}></span>
                            </div>
                        </li>
{/* ---------------------------------- */}
                        <li className={styles.step_wrap_li}>
                            <div className={styles.step_area}>
                                <div className={styles.step}>
                                    <strong>STEP 8</strong>
                                    <span>12월</span>
                                </div>
                            </div>
                            <div className={styles.step_box}>
                                <strong><font className="f_c_blue">이사회</font> 의결</strong>
                                {/* <span className={styles.bul}>일반회원 승인</span> */}
                                <div className={`${styles.bn_wrap} ${styles.step_list}`}>
                                    <ul className={styles.bul_list}>
                                        <li>일반회원 최종 승인</li>
                                        <li>정회원, 외국회원, 원로회원 최종 후보자 확정</li>
                                    </ul>
                                </div>
                                <span className={styles.bg_m}></span>
                            </div>
                        </li>
{/* ---------------------------------- */}
                        <li className={styles.step_wrap_li}>
                            <div className={styles.step_area}>
                                <div className={styles.step}>
                                    <strong>STEP 9</strong>
                                    <span>12월 말</span>
                                </div>
                            </div>
                            <div className={styles.step_box}>
                                <strong><font className="f_c_blue">총회</font> 승인</strong>
                                {/* <span className={styles.bul}>現 정회원을 대상으로 한 서면투표 진행</span> */}
                                <div className={`${styles.bn_wrap} ${styles.step_list}`}>
                                    <ul className={styles.bul_list}>
                                        <li>정회원, 외국회원, 원로회원 최종 승인</li>
                                        <li>신입회원의 임기는 심사 이듬해 1월 1일부터 시작</li>
                                    </ul>
                                </div>
                                <span className={styles.bg_m}></span>
                            </div>
                        </li>
{/* ---------------------------------- */}
                    </ul>
                </div>
            </div>
        </>
    );
}

export default Progress;